module.exports = __webpack_public_path__ + "static/img/DavidKing.48c0e94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DavidKing.jpg
// module id = Gpmx
// module chunks = 0